<template>
  <div id="app">
    <navbar-atas></navbar-atas>
    <router-view></router-view>
    <audio-player v-bind:data="audio"></audio-player>
  </div>
</template>

<script>
import NavbarAtas from './components/Navbar.vue';
import Player from './components/Audio.vue';
import axios from 'axios';

export default {
  components: {
    'navbar-atas': NavbarAtas,
    'audio-player': Player,
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      audio: [],
      proxy: 'https://cors-anywhere.herokuapp.com/',
      url: 'https://al-quran-8d642.firebaseio.com/data.json?print=pretty',
      test: [],
    }
  },
    created(){
        axios.get(`${this.proxy}${this.url}`)
        .then(res => {
            const hasil = [];
            res.data.forEach((el,i) => {
                hasil[i] = {}
                hasil[i]['audio'] = res.data[i].audio;
                hasil[i]['nama'] = res.data[i].nama;
                hasil[i]['arti'] = res.data[i].arti;
            });
            this.audio = hasil;
        })
    },
}
</script>
